import { render, staticRenderFns } from "./importDetail.vue?vue&type=template&id=619dd5d9&scoped=true&"
import script from "./importDetail.vue?vue&type=script&lang=js&"
export * from "./importDetail.vue?vue&type=script&lang=js&"
import style0 from "./importDetail.vue?vue&type=style&index=0&id=619dd5d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619dd5d9",
  null
  
)

export default component.exports